module.exports = __webpack_public_path__ + "static/media/home-caro-7.234e4af6.png";